import { render, staticRenderFns } from "./print-scheduling-detail.vue?vue&type=template&id=20bcb1f8&scoped=true"
import script from "./print-scheduling-detail.vue?vue&type=script&lang=js"
export * from "./print-scheduling-detail.vue?vue&type=script&lang=js"
import style0 from "./print-scheduling-detail.vue?vue&type=style&index=0&id=20bcb1f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bcb1f8",
  null
  
)

export default component.exports